/* eslint-disable */
import React from 'react';
// import PropTypes from 'prop-types';
// import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import GridItem from "components/Grid/GridItem.jsx";
// import GridContainer from "components/Grid/GridContainer.jsx";

// core components
import Button from "components/CustomButtons/Button.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardHeader from "components/Card/CardHeader.jsx";

// @material-ui/icons
import Payment from "@material-ui/icons/Style";
import Settlement from "@material-ui/icons/DoneAll";
import Dashboard from "@material-ui/icons/Dashboard";
import Report from "@material-ui/icons/Report";
import Passengers from "@material-ui/icons/AirlineSeatReclineNormal";
import Settings from "@material-ui/icons/SettingsApplications";
//core components
import CardIcon from "components/Card/CardIcon.jsx";
import { primaryColor } from "assets/jss/material-dashboard-react.jsx";
import Faan from 'assets/img/faan_logo.png';
import { Link } from 'react-router-dom';
import "../landing.css"
// import Logout from "@material-ui/icons/PowerSettingsNew";
// import {appConstants} from "../../../_constants";
import Authorization from "../component/Authorization";

const MyComponent = ({classes, user, styles, setView}) => {
    const props_ = {
        styles: styles,
        user: user,
        classes: classes,
        setView: setView
    };
    
    
    return (
        <div className={`root ${classes.root}`}>
            <div className={classes.rootOverlay}>

                <Authorization {...props_}/>

                <Grid container className={classes.center2}>
                    <Grid item lg={6} sm={12}>
                        <div style={{ margin: '15px 0 20px' }}><img src={Faan} /></div>
                    </Grid>
                </Grid>
                <Grid container className={classes.center2} style={{ paddingTop: '0' }}>
                    <GridItem container lg={10} sm={12}>
                        <Grid container>
                            <Grid item lg={4} sm={12} className={classes.card}>
                                <Card chart>
                                    <Link to="app/passenger-data" className={'animate-card-container'}>
                                        <CardHeader color={setView === "regional" ? "regional" : "success"} className={'animate-card-header'}>
                                            <div style={{ textAlign: "center", margin: "0" }}>
                                                <Passengers style={{ fontSize: "60px" }} />
                                            </div>
                                            <h4 style={styles.title}>Passenger Data</h4>
                                        </CardHeader>
                                        <CardBody>
                                            <p style={{ color: '#000' }}>
                                                Domestic airline flights and passenger manifest.
                                            </p>
                                            <Button
                                                type="button"
                                                color={setView === "regional" ? "regional" : "success"}
                                            >
                                                Explore
                                            </Button>
                                        </CardBody>
                                    </Link>

                                </Card>
                            </Grid>
                            <Grid item lg={4} sm={12} className={classes.card}>
                                <Card chart>
                                    <Link to="/app/airline-payment" className={'animate-card-container'}>
                                        <CardHeader color="warning" className={'animate-card-header'}>
                                            <div style={{ textAlign: "center", margin: "0" }}>
                                                <Payment style={{ fontSize: "60px" }} />
                                            </div>
                                            <h4 style={styles.title}>Airline Payment </h4>
                                        </CardHeader>
                                        <CardBody>
                                            <p style={{ color: '#000' }}>
                                                Tokens purchased by airlines in real-time.
                                            </p>
                                            <Button
                                                type="button"
                                                color="warning"
                                                // style={{background: '#23c3d6'}}
                                            >
                                                Explore
                                            </Button>
                                        </CardBody>
                                    </Link>
                                </Card>
                            </Grid>
                            <Grid item lg={4} sm={12} className={classes.card}>
                                <Card chart>
                                    <Link to="/app/psc-settlement" className={'animate-card-container'}>
                                        <CardHeader color="info" className={'animate-card-header'}>
                                            <div style={{ textAlign: "center", margin: "0" }}>
                                                <Settlement style={{ fontSize: "60px" }} />
                                            </div>
                                            <h4 style={styles.title}>PSC Settlement </h4>
                                        </CardHeader>
                                        <CardBody>
                                            <p style={{ color: '#000' }}>
                                            Module reconciles flown passenger with tokens purchased
                                            </p>
                                            <Button
                                                type="button"
                                                color="info"
                                            >
                                                Explore
                                            </Button>
                                        </CardBody>
                                    </Link>
                                </Card>
                            </Grid>
                        </Grid>

                        <GridItem container lg={12} sm={12}>
                            <Grid item lg={4} sm={12} className={classes.card}>
                                <Link to="/app/dashboard">
                                    <Card>
                                        <CardHeader color="success" stats icon>
                                            <CardIcon color="success">
                                                <Dashboard />
                                            </CardIcon>
                                            <div className={'landing-mini-header-text'}>
                                                Dashboard
                                            </div>
                                        </CardHeader>
                                        <CardBody />
                                    </Card>
                                </Link>
                            </Grid>

                            <Grid item lg={4} sm={12} className={classes.card}>
                                <Link to="/app/settings">
                                    <Card>
                                        <CardHeader color="warning" stats icon>
                                            <CardIcon color="warning">
                                                <Settings />
                                            </CardIcon>
                                            <div className={'landing-mini-header-text'}>
                                                Settings
                                            </div>
                                        </CardHeader>
                                        <CardBody />
                                    </Card>
                                </Link>
                            </Grid>
                            <Grid item lg={4} sm={12} className={classes.card}>
                                <Link to="/reports-landing">
                                    <Card>
                                        <CardHeader stats icon>
                                            <CardIcon color="info">
                                                <Report />
                                            </CardIcon>
                                            <div className={'landing-mini-header-text'}>
                                                Reports
                                            </div>
                                        </CardHeader>
                                        <CardBody />
                                    </Card>
                                </Link>
                            </Grid>
                            <Grid item lg={4} sm={12} className={classes.card}>
                                <Link to={setView === "regional" ? "/app/psc-regional/help-center" : "/app/help-center"} className={'animate-card-container'}>
                                    <Card>
                                        <CardHeader  color={setView === "regional" ? "regional" : "success"} stats icon>
                                            <CardIcon  color={setView === "regional" ? "regional" : "success"}>
                                                <Amount style={{ fontSize: "60px" }} />
                                            </CardIcon>
                                            <div className={'landing-mini-header-text'}>
                                                Help Center
                                            </div>
                                        </CardHeader>
                                        <CardBody />
                                    </Card>
                                </Link>
                            </Grid>
                        </GridItem>

                    </GridItem>

                </Grid>
            </div>
        </div >
    );
};

export default MyComponent;



// WEBPACK FOOTER //
// ./src/layouts/Landing/roles/airportManager.js